module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/~/babel-runtime/core-js/object/assign.js
 ** module id = 323
 ** module chunks = 0
 **/